import Button, {ButtonProps} from "@mui/material/Button"
import {styled} from "@mui/material/styles"
import React from "react"

// Primary action button (Next, Continue, Start My Free Check). Colour (Logo
// Blue), white text, rounded shape and no-caps come from the theme; callers
// should NOT pass an inline backgroundColor. Primary CTAs use a 56px height
// (the brief's ideal); the theme's 48px minimum applies to all other buttons.
const CustomButton = styled(Button)<ButtonProps>(() => ({
  minHeight: 56
}))

export const AppButton: React.FC<ButtonProps> = (props: ButtonProps) => {
  return <CustomButton variant="contained" color="primary" {...props} />
}

export default AppButton
